import { render } from "./EditPetDashboard.vue?vue&type=template&id=56a87c3a&scoped=true"
import script from "./EditPetDashboard.vue?vue&type=script&lang=js"
export * from "./EditPetDashboard.vue?vue&type=script&lang=js"

import "./EditPetDashboard.vue?vue&type=style&index=0&id=56a87c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a87c3a"]])

export default __exports__